import React from 'react'
import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import IconContainer from './IconContainer'
import IconLabel from './IconLabel'

const ApprovedIcon = ({ label, color, variant }) => {
    return (
        <Box display="flex" alignItems="center">
            <IconContainer bgcolor="#d0021b">
                <Icon name="Close" color="#ffffff" width="15px" height="15px" />
            </IconContainer>
            <IconLabel style={{ color: '#d0021b' }}>{label}</IconLabel>
        </Box>
    )
}

export default ApprovedIcon
